export const PRIVACY_POLICY = 'https://cutwise.com/privacy';
